import React, { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

import { Tab, Tabs } from 'src/components/core';
import { ExpandOut, ExpandIn } from 'src/components/core/icons';
import { FlexContainer, StyledFlexContainer } from 'src/components/core/layout/FlexContainer';

interface ChartHeaderProps {
    activeTab: string;
    setActiveTab: Dispatch<SetStateAction<string>>;
    isCharExpand: boolean;
    setIsChartExpand: Dispatch<SetStateAction<boolean>>;
}

const StyledChartHeader = styled(StyledFlexContainer)`
    width: 100%;
    justify-content: space-between;
    padding: 8.5px 24px;
    & svg {
        width: 20px;
        height: 20px;
    }
    ${({ theme: { colors, typography } }) => `
        border-bottom: 1px solid ${colors.border.light};
        > div:first-of-type {
            font-size: ${typography.size.desktop.paragraph.p2};
            line-height: calc(${typography.lineHeight[3]} - 0.5px);
            font-weight: ${typography.weight.medium};
            padding: 4.5 0;
        }
        .chart-tab {
            font-size: ${typography.size.desktop.paragraph.p3};
            line-height: calc(${typography.lineHeight[2]} - 1px);
            padding: 6px 8px;
            :first-of-type {
                margin-right: 0;
            }
            &.tab-active {
                border: 0;
                color: ${colors.primary};
                background: ${colors.background.secondary.v4};
                border-radius: 4px;
            }
        }
    `};
`;

const ChartHeader: FC<ChartHeaderProps> = ({
    activeTab,
    setActiveTab,
    isCharExpand,
    setIsChartExpand,
}) => {
    const { t } = useTranslation();
    const { colors } = useTheme();

    const setExpandView = () => {
        setIsChartExpand && setIsChartExpand(!isCharExpand);
    };
    return (
        <StyledChartHeader>
            <div>{t('chart')}</div>
            <FlexContainer>
                <Tabs value={activeTab} onChange={setActiveTab}>
                    <Tab
                        key={0}
                        label={t('trading_view')}
                        value={'chart'}
                        className={'chart-tab'}
                    />
                    <Tab key={1} label={t('depth')} value={'depth'} className={'chart-tab'} />
                </Tabs>
                {isCharExpand ? (
                    <ExpandIn
                        stroke={colors.text.tertiary}
                        onClick={setExpandView}
                        className={'clickable'}
                    />
                ) : (
                    <ExpandOut
                        stroke={colors.text.tertiary}
                        onClick={setExpandView}
                        className={'clickable'}
                    />
                )}
            </FlexContainer>
        </StyledChartHeader>
    );
};

export { ChartHeader };
